import { BaseIcon, BaseIconProps } from "./baseIcon";

export const EarnIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 19C13.866 19 17 15.866 17 12C17 8.13401 13.866 5 10 5C6.13401 5 3 8.13401 3 12C3 15.866 6.13401 19 10 19ZM10 21C14.9706 21 19 16.9706 19 12C19 7.02944 14.9706 3 10 3C5.02944 3 1 7.02944 1 12C1 16.9706 5.02944 21 10 21Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        d="M10 7C10.5523 7 11 7.44772 11 8H12C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10H9V11H12C12.5523 11 13 11.4477 13 12V15C13 15.5523 12.5523 16 12 16H11C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16H8C7.44772 16 7 15.5523 7 15C7 14.4477 7.44772 14 8 14H11V13H8C7.44772 13 7 12.5523 7 12V9C7 8.44772 7.44772 8 8 8H9C9 7.44772 9.44772 7 10 7Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        d="M15.6203 3.72962C15.3518 3.54661 15.4854 3.11807 15.8039 3.18284C19.9099 4.01795 22.9999 7.64751 22.9999 12.0002C22.9998 16.3529 19.9099 19.9825 15.8039 20.8176C15.4854 20.8824 15.3518 20.4538 15.6203 20.2708C16.6993 19.5353 17.6263 18.5936 18.3466 17.5031C18.3641 17.4767 18.3855 17.4531 18.4101 17.4331C19.9893 16.1497 20.9998 14.1938 20.9999 12.0002C20.9999 9.80647 19.9896 7.84985 18.4101 6.56641C18.3855 6.54643 18.3641 6.52284 18.3466 6.49641C17.6263 5.40614 16.6993 4.46488 15.6203 3.72962Z"
        className="oui-fill-base-contrast-80"
      />
    </BaseIcon>
  );
};
